<template>
    <div class="account-wrapper">
        <div class="header">
            <router-link
                to="/login"
                class="logo-link"
            >
                <img
                    class="logo"
                    src="../../assets/img/logo.svg"
                    alt=""
                >
            </router-link>
        </div>
        <div class="main-box">
            <div class="header-box">
                找回密码
            </div>
            <div class="main-area">
                <el-form
                    class="form__center form__home"
                    label-width="72px"
                    style="width: 380px"
                    size="small"
                >
                    <el-form-item
                        label="账号："
                    >
                        <el-input
                            v-model="formItem.merchants_no"
                            placeholder="请输入账号/商户号"
                        />
                    </el-form-item>
                    <el-form-item
                        label="验证码："
                        style="width: 425px"
                    >
                        <div class="form-group">
                            <el-input
                                v-model="captcha"
                                placeholder="请输入图片验证码"
                                style="width: 200px"
                            />
                            <div class="captcha-wrapper">
                                <Captcha
                                    :identify-code="captchaCode"
                                    :content-width="100"
                                    :content-height="28"
                                />
                            </div>
                            <el-link
                                :underline="false"
                                style=""
                                type="info"
                                @click="refreshCaptcha"
                            >
                                换一张
                            </el-link>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            class="btn-standard"
                            type="primary"
                            @click="onSubmit"
                        >
                            下一步
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="footer">
            <div class="copyright">
                © 2019 北京奇点在线科技有限公司&nbsp;<el-divider direction="vertical"/>&nbsp;京ICP备18055826号
            </div>
        </div>
    </div>
</template>

<script>
import Captcha from '../../components/Captcha'
import Vue from 'vue'
import qs from 'qs'
import router from '@/router'
import { Divider, Link } from 'element-ui'

Vue.use(Link)
Vue.use(Divider)
export default {
    name: 'Main',
    components: { Captcha },
    data () {
        return {
            url: '',
            captchaCode: '1234',
            captcha: '',
            formItem: {
                merchants_no: ''
            }
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.merchants_no': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入账号/商户号'
            }
        ],
        'captcha': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入图形验证码'
            },
            {
                test (val) {
                    return val.toUpperCase() === this.captchaCode
                },
                message: '请输入正确的图形验证码'
            }
        ]
    },
    created () {
        this.createCode()
    },
    methods: {
        createCode () {
            let code = ''
            let codeLength = 4
            let random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
            for (let i = 0; i < codeLength; i++) {
                let index = Math.floor(Math.random() * 36)
                code += random[index]
            }
            this.captchaCode = code
        },
        refreshCaptcha () {
            this.createCode()
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/findsetpwd', qs.stringify({
                    step: 0,
                    username: this.formItem.merchants_no,
                    code: this.formItem.code
                })).then(res => {
                    if (res.code === 0) {
                        router.replace(`/account/entry/step1?username=${res.data.username}&phone=${res.data.phone}`)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/account.scss";

    .form__home {
        padding-top: 100px;
    }

    .form-group {
        display: flex;
        align-items: center;
    }

    .captcha-wrapper {
        height: 30px;
        margin: 0 4px;
        background-color: $--color-border-base;
        border: 1px solid $--color-border-base;
        box-sizing: border-box;

        .captcha {
            display: block;
            max-height: 30px;
            border-radius: 2px;
        }
    }
</style>
